import { useState, useEffect, useRef } from 'react';
import { searchAddressAutocomplete } from '../api';

const useAddressAutocomplete = (debounceMs = 400) => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const abortRef = useRef(null);

    useEffect(() => {
        if (query.length < 3) {
            setSuggestions([]);
            return;
        }

        const timer = setTimeout(async () => {
            abortRef.current?.abort();
            abortRef.current = new AbortController();

            setIsLoading(true);
            try {
                const results = await searchAddressAutocomplete(query, abortRef.current.signal);
                setSuggestions(results);
            } catch {
                // aborted or error — ignore
            } finally {
                setIsLoading(false);
            }
        }, debounceMs);

        return () => clearTimeout(timer);
    }, [query, debounceMs]);

    const clear = () => {
        setQuery('');
        setSuggestions([]);
    };

    return { query, setQuery, suggestions, isLoading, clear };
};

export default useAddressAutocomplete;
